import axios from './custom_axios';
import cookies from 'js-cookie'

const API_URL = process.env.REACT_APP_API_URL;
const saveTransaction = async (transactionDetails) => {
    try {
        const response = await axios.get(`${API_URL}/api/transaction`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(transactionDetails),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error("Lưu giao dịch thất bại.");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};


const updateWallet = async (balance) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/v1/update_wallet`,
            { balance },
            {
                headers: {
                    'Authorization': `Bearer ${cookies.get("Token")}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error updating wallet:', error.response ? error.response.data : error.message);
        throw error;
    }
};

export { saveTransaction, updateWallet }
